import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Popconfirm, Table, message, Spin, Select, Input, Button, Modal, Tabs, DatePicker } from 'antd';
import $ from '../../../common/AjaxRequest';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import RegisterRequest from './RegisterRequest';
import ApproveCancelApply from './ApproveCancelApply';
import BaBatchTransfer from './BaBatchTransfer';
import ApproveBaBatchTransfer from './ApproveBaBatchTransfer';
import ExpectHour from './ExpectHour';
import ConterctRelateSite from './ConterctRelateSite';
import AuditJDE from './AuditJDE';
import moment from 'moment';
import '../style/notice.less';
import { saveParams, saveSearchParams } from '../../../actions/noticeActions';
import { saveParams as saveProjectParams } from '../../../actions/investigationActions';
import { saveParams as saveResumeParams } from '../../../actions/PersonalActions';


import fp from '../../../utils/fp';
import TableC from '../../basicElement/TableC';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import BacthHandle from './BacthHandle';
import RoleSelectionModal from '../../investigation/RoleSelectionModal';

const { Option } = Select;
const TabPane = Tabs.TabPane;

const parseQueryConditions = (queryConditions,isSplitValue, splitType = ',') => {
    const fields = (queryConditions || '').split(splitType);
    const params = {};
    for (let i = 0, len = fields.length; i < len; i++) {
        const keyValue = fields[i].split('=');
        if(isSplitValue){
            params[keyValue[0]] =( keyValue[1]+'').replace(/_/g,',');
        }else{
            params[keyValue[0]] = keyValue[1];
        }
    }
    
    return params;
};
const clearCenter = (setSession) => {
    setSession.invId = "";
    setSession.invName = "";
    setSession.investigationSiteCode = "";
    setSession.investigationSiteName = "";
    setSession.siteId = "";
};
const setProject = (setSession, item, isCenter) => {
    setSession.invId = item.investigationId;
    setSession.invName = item.investigationName;
    setSession.investigationSiteCode = "";
    setSession.investigationSiteName = isCenter ? "中心汇总" : '';
    setSession.siteId = '';
};
const setCenter = (setSession, item) => {
    setSession.invId = item.investigationId;
    setSession.invName = item.investigationName;
    setSession.investigationSiteCode = item.investigationSiteCode;
    setSession.investigationSiteName = item.investigationSiteName;
    setSession.siteId = item.investigationSiteId;
};

class Filter extends Component {
    state = {
        searchParams: {},
        planFteAdjustment: 0,
        contractSiteRelate:0,
        infoConfirm: 0,
    }

    componentDidMount() {
        const { searchParams } = this.props;
        const { noticeType } = searchParams || {};
        this.setState({
            searchParams: { ...searchParams },
            planFteAdjustment: noticeType=='PLAN_FTE_ADJUSTMENT' ? 1 : 0,
            contractSiteRelate: noticeType=='CONTRACT_RELATE_SITE' ? 1 : 0,
            infoConfirm: noticeType=='SSU_HOSPITAL_INFO_CONFIRM' ? 1 : 0,
        }, () => {
            this.search();
        });
        this.props.saveSearchParams({ noticeType: undefined, noticeValue: undefined, activeKey: undefined });
    }

    search = () => {
        const { searchParams, planFteAdjustment, contractSiteRelate, infoConfirm } = this.state;
        this.props.search({ ...searchParams, planFteAdjustment, contractSiteRelate, infoConfirm });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams.noticeType = value.noticeType;
        searchParams.noticeValue = value.noticeValue;
        if (value.noticeValue) {
            this.setState({ planFteAdjustment: 0, contractSiteRelate:0, infoConfirm:0 });
        }
        this.setState({ searchParams });
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    handleDateChange = (date, dateString) => {
        const { searchParams } = this.state;
        searchParams.noticeDate = dateString;
        this.setState({ searchParams });
    }

    // 批量标记已完成
    bacthHandleComplate = () => {
        this.props.bacthHandleComplate()
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        const { value: id, text: name } = value;
        searchParams[`${key}Id`] = id;
        searchParams[`${key}Name`] = name;
        this.setState({ searchParams })
    };


    render() {
        const { searchParams: { noticeValue, investigationName } } = this.state;
        return (
            <div style={{ width: "80%", margin: "0 auto", marginBottom: "15px" }}>
                <span style={{ marginRight: "10px" }}>消息类型</span>
                <SearchRetrieve
                    keyword='noticeValue'
                    allowClear={true}
                    style={{ width: 160 }}
                    params={{ limit: 20 , configureType: 'USER_SCHEDULE' }}
                    placeholder="输入名称检索"
                    value={noticeValue}
                    url={API_URL.notice.queryNoticeConfigureList}
                    config={{ id: 'noticeConfigureId', name: 'noticeValue' }}
                    onChange={option => this.handleSelectChange(option, 'noticeType')}
                />
                <span style={{ marginLeft: "10px", marginRight: "10px" }}>项目简称</span>
                <SearchRetrieve
                    keyword='investigationName'
                    allowClear={true}
                    style={{ width: 160 }}
                    params={{ limit: 20 }}
                    placeholder="输入名称检索"
                    value={investigationName}
                    url={API_URL.investigation.queryInvestigationByName}
                    config={{ id: 'investigationId', name: 'investigationName' }}
                    onChange={option => this.handleChange(option, 'investigation')}
                />
                <span style={{ marginLeft: "10px", marginRight: "10px" }}>通知时间</span>
                <DatePicker disabledDate={current => { return current && current.valueOf() > Date.now()}} onChange={(date, dateString) => this.handleDateChange(date, dateString)} />
                <Button style={{ marginLeft: 10 }} type="primary" onClick={this.search}>搜索</Button>
                <Button style={{ marginLeft: 10 }} type="primary" onClick={this.bacthHandleComplate}>批量标记为已处理</Button>
            </div>
        );
    }
}

class Backlog extends Component {
    state = {
        pagination: {
            pageSize: 10,
            current: 1,
        },
        loading: false,
        data: [],
        ids: [],
        auditJdeParams: {
            showAuditJDE: false,
        },
        expectHourParams: {
            visible: false,
        },
        loading: false,
        stageList: [],
        searchParams: {},
        centerRelateParams:{
            visible: false,
        }
    }

    loadData = () => {
        const { searchParams, pagination, pagination: { pageSize, current } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.home.queryTodayNoticeAll,
            data: {
                limit: pageSize,
                offset: current,
                ...searchParams,
                queryType:'userSchedule'
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    pagination,
                    data: datas,
                    loading: false,
                });
            }
        };
        $.sendRequest(options);
    }
    //搜索
    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: {...params}
        }, () => {
            this.loadData();
        });
    }

    hideAuditJDE = () => {
        const { auditJdeParams } = this.state;
        auditJdeParams.showAuditJDE = false;
        this.setState({ auditJdeParams });
    }

    hideExpectHour = () => {
        const { expectHourParams } = this.state;
        expectHourParams.visible = false;
        this.setState({ expectHourParams });
    }
    hideCenterctRelateSite = () => {
        const { centerRelateParams } = this.state;
        centerRelateParams.visible = false;
        this.setState({ centerRelateParams });
    }

    // 批量标记已完成
    bacthHandleComplate = () => {
        this.bacthHandleRef.show()
    }

    //标记已处理
    handleComplate = (params, userScheduleId) => {
        const options = {
            method: 'POST',
            url: API_URL.notice.markScheduleDeal,
            data: {
                ...params,
                userScheduleId,
            },
            dataType: 'json',
            doneResult: res => {
                if (res && res.success) {
                    message.success(res.success);
                    this.loadData();
                    window.dispatchEvent(new CustomEvent('smo:notice-count-refresh'));
                } else {
                    message.error((res && res.error) || '标记失败');
                }
            },
        };
        $.sendRequest(options);
    }

    // 新人带教老师登记通知
    handleRegisterTeacher = (noticeId, params) => {
        const { userId, isDirectSupervisor, ...rest } = params;
        Modal.confirm({
            title: '是否现在去登记此新人的带教老师？',
            okText: '是，现在去登记带教老师',
            cancelText: '否，此人员无需登记带教老师',
            width: 490,
            onOk: () => {
                const { saveParams } = this.props;
                let href = '/#/teaching/management';
                if (isDirectSupervisor == 1) {
                    rest.activeKey = 'promotion';
                    href = '/#/user/userInfo';
                }
                saveParams(rest);
                location.href = href;
            },
            onCancel: () => {
                Fetch.post(API_URL.notice.setNotNeedTeacher, {
                    userId
                }).then(res => {
                    message.success(res.success);
                }).catch(err => {
                    console.error(err);
                });
            },
        });
        this.confirmNoticeReadByOne(noticeId);
    }
    // 中心关联合同通知
    handlContractRelateModal = (noticeId, params, centerRelateShow) => {
        const { readStatus, handlerStatus } = params;
        if(!handlerStatus){
            const { centerRelateParams } = this.state;
            centerRelateParams.visible = centerRelateShow;
            centerRelateParams.noticeId = noticeId;
            centerRelateParams.readStatus = readStatus;
            this.setState({ centerRelateParams });
        }else{
            message.error('该条提醒已经处理');
        }
    }

    //访视周期计划审批
    handleVisitApproval = params =>{
        const { path, handlerStatus, target, } = params;
        if(handlerStatus){
            message.error('该条提醒已经处理');
            return
        }
        if (path !== "javascript:void(0)" || path) {
            if( target == 'inInv') {
                // 保存页面查询参数至store
                const { saveParams } = this.props;
                if (Object.keys(params).length !== 0) {
                    saveParams({...params});
                }
            }
            location.href = path;
        }
    }

    autoRegisterRequest = (setSession, params) => {
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.selectContractForAddRemittance, {
            investigationId: params.investigationId,
            type: 'application',
            isModify: 0,
        }).then(res => {
            const { data } = res;
            this.setState({ loading: false }, () => {
                this.setSession(setSession);
                this.props.saveParams({ ...params, autoAdd: true });
                location.href = '/#/contractManagement/requestRecord';
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    handleRequestRegister = (setSession, params) => {
        const { webCondition } = params;
        if (webCondition === 'NOT_POP') {
            this.autoRegisterRequest(setSession, params);
        } else if (webCondition !== 'NOT_JUMP') {
            this.requestRef.show(setSession, params);
        }
    }

    handleResumeNotice =(params) =>{
        const myuserId = sessionStorage.userId;
        const {userId,typeName,workStatus} = params;
        if(myuserId == userId){
            this.props.saveResumeParams({
                ...params,
                isChinese:typeName=='CHINESE'?true:false,
                canEdit:workStatus?workStatus=='WORKING':true,
                showModal :true,
            })
            location.href = './#/personal/curriculumVitae'
        }else{
            this.props.saveResumeParams({
                ...params,isChinese:typeName=='CHINESE'?true:false,
                canEdit:workStatus?workStatus=='WORKING':true,
                showModal :true,
            })
            location.href = './#/user/curriculumVitae'
        }
    }
    
    handleNationalVerificationNotice = (params) =>{
        this.props.saveParams({...params});
        location.href = './#/qualityManagement/nationalverification';
    }

    // 重大事件-项目内跳转（需查询角色）
    handleMajorEventInInv = (record, userScheduleId, queryConditions) => {
        const { investigationId, investigationName, investigationSiteId, investigationSiteName, investigationSiteCode, targetWeb } = record;

        // 解析查询条件，将重大事件编号/单号存入sessionStorage，供重大事件页面自动过滤
        const queryParams = parseQueryConditions(queryConditions);
        if (queryParams.majorEventNumber) {
            sessionStorage.majorEventNumber = queryParams.majorEventNumber;
        }
        if (queryParams.primaryEventNumber) {
            sessionStorage.primaryEventNumber = queryParams.primaryEventNumber;
        }

        this.confirmNoticeReadByOne(userScheduleId);

        const setSession = {};
        if (targetWeb === 'IN_INV_SITE_MAJOR_EVENT') {
            setSession.invId = investigationId;
            setSession.invName = investigationName;
            setSession.investigationSiteCode = investigationSiteCode;
            setSession.investigationSiteName = investigationSiteName;
            setSession.siteId = investigationSiteId;
        } else {
            setSession.invId = investigationId;
            setSession.invName = investigationName;
            setSession.investigationSiteCode = "";
            setSession.investigationSiteName = "中心汇总";
            setSession.siteId = '';
        }
        this.setSession(setSession);

        const options = {
            method: 'POST',
            url: API_URL.user.getRoleListForInvestigation,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { roles } = res.data;
                const { curRole } = sessionStorage;
                if (roles.length > 1) {
                    this.roleSelectionModelRef.show(roles, { investigationId, investigationName });
                } else if (roles.length == 1) {
                    const role = roles[0] === 'KAM' ? 'TAL' : roles[0];
                    sessionStorage.curRole = role;
                    location.href = '/#/execute/importantEvent';
                } else if (curRole == 'CRCC' || curRole == 'CRCM') {
                    sessionStorage.curRole = curRole;
                    location.href = '/#/execute/importantEvent';
                } else {
                    message.warning('该人员在项目上没有分配角色！');
                }
            },
        };
        $.sendRequest(options);
    }

    // 重大事件-角色选择回调
    selectRoleForMajorEvent = (role, roles, investigation) => {
        const newRole = role === 'KAM' ? 'TAL' : role;
        const isKeyAccountManager = role === 'KAM' ? true : false;
        const newRoles = typeof(roles) === 'string' ? roles : roles.map(el => el === 'KAM' ? 'TAL': el);
        sessionStorage.isKeyAccountManager = isKeyAccountManager;
        sessionStorage.roles = newRoles;
        sessionStorage.curRole = newRole;
        location.href = '/#/execute/importantEvent';
    }

    //办事流程
    showWorkFlow = (record) => {
        const { hospitalId = '', hospitalName = '', relateId } = record;
        sessionStorage.hospitalId = hospitalId;
        sessionStorage.hospitalName = hospitalName;
        sessionStorage.relateId = relateId;
        location.href = `./#/hospital/workFlow`;
    }

    setSession = (setSession) => {
        if (Object.keys(setSession).length !== 0) {
            for (let [k, v] of Object.entries(setSession)) {
                sessionStorage[k] = v;
            }
        }
    }
    //处理消息点击
    handelClickNotice = (path, setSession, noticeId, index, params) => {
        console.log(path);
        switch(path) {
            case 'NATION_VERIFY_ADD':{
                this.handleNationalVerificationNotice(params);
                this.confirmNoticeReadByOne(noticeId);
                break;
            }
            case "VISIT_APPROVAL":{
                this.handleVisitApproval(params);
                this.setSession(setSession);
                this.confirmNoticeReadByOne(noticeId);
                break;
            }
            case 'VITAE_APPROVAL':{
                this.handleResumeNotice(params);
                this.confirmNoticeReadByOne(noticeId);
                break;
            }
            //中心关联
            case 'CONTRACT_RELATE_SITE': {
                this.handlContractRelateModal(noticeId, params, true, setSession);
                this.setSession(setSession);
                break;
            }
            case 'USER_TEACHER_REMIND': {
                this.handleRegisterTeacher(noticeId, params);
                break;
            }
            case 'AUTHORITY': {
                this.confirmNoticeReadByOne(noticeId);
                this.props.saveProjectParams({ feedBack: true, searchParams: params, current: params.activeKey });
                this.setSession(setSession);
                location.href = '/#/invList';
                break;
            }
            case 'REMITTANCE_REGISTER': {
                this.confirmNoticeReadByOne(noticeId);
                this.handleRequestRegister(setSession, params);
                break;
            }
            case 'CASH_REQ_NODE_REACH':
            case 'MILESTONE_REACH_NOTICE':
            case 'MILESTONE_DATE_REACH_NOTICE': {
                this.confirmNoticeReadByOne(noticeId);
                if (params.webCondition === 'NOT_JUMP') {
                    break;
                }
                if (path === 'MILESTONE_REACH_NOTICE' && setSession.curRole === 'PML') {
                    break;
                }
                if (setSession.curRole === 'PM') {
                    this.props.saveParams(params);
                    this.setSession(setSession);
                    location.href = '/#/projectContract/requestRecord';
                } else {
                    this.props.saveParams(params);
                    this.setSession(setSession);
                    location.href = '/#/contractManagement/requestRecord';
                }
                break;
            }
            case 'CONTRACT_MODIFY_NOTICE': {
                this.confirmNoticeReadByOne(noticeId);
                this.props.saveParams(params);
                this.setSession(setSession);
                if (setSession.invId > 0) {
                    location.href = '/#/projectContract/contractInfoChange';
                } else {
                    location.href = '/#/contractManagement/contractInfoChange';
                }
                break;
            }
            case 'INVESTIGATION_FINISH_PERCENT_CONFIRM':
                this.confirmNoticeReadByOne(noticeId);
                this.props.saveParams({...params});
                location.href = '/#/home/myFocus';
                break;
            case 'SSU_HOSPITAL_INFO_CONFIRM':
                this.showWorkFlow(params);
                this.confirmNoticeReadByOne(noticeId);
                break;
            default: {
                this.confirmNoticeReadByOne(noticeId);

                // 保存页面查询参数至store
                const { saveParams } = this.props;
                if (Object.keys(params).length !== 0) {
                    saveParams({...params});
                }
                
                this.setSession(setSession);
                if (path !== "javascript:void(0)" || path) {
                    location.href = path;
                }
            }
        }
    }
    //确认已读
    confirmNoticeReadByOne = (noticeId) => {
        const options = {
            method: 'POST',
            url: API_URL.home.confirmNoticeReadByOne,
            data: { noticeId, queryType:'userSchedule' },
            dataType: 'json',
            doneResult: () => {
                this.loadData();
                window.dispatchEvent(new CustomEvent('smo:notice-count-refresh'));
            }
        };
        $.sendRequest(options);
    }
    
    //点击消息回调
    clickNotice = (text , record , index) => {
        const {
            userScheduleId, 
            noticeInfo,
            queryConditions, 
            noticeType, 
            targetWeb,
            webCondition, 
            relateId, 
            roleCode, 
            readStatus,
            investigationId = '',
            investigationName = '',
            investigationSiteId = '', 
            investigationSiteName = '',
            investigationSiteCode = '',
        } = record;
        let type = null;
        let path = 'javascript:void(0)';
        let params = {
            ...parseQueryConditions(queryConditions), 
            investigationId, 
            investigationName, 
            investigationSiteId, 
            investigationSiteName, 
            investigationSiteCode,
            webCondition,
        };
        const setSession = {};
        switch (noticeType) {
            case 'HOSPITAL_DIRECTOR_CHANGE':
                type = '医院负责人变更通知';
                path = '/#/hospital/detail';
                params = parseQueryConditions(queryConditions);
                break;
            case 'HOSPITAL_DEPARTMENT_DIRECTOR_CHANGE':
                type = '科室负责人变更通知';
                path = '/#/hospital/departmentDetail';
                params = parseQueryConditions(queryConditions);
                break;
            case 'HOSPITAL_DEPART_CHARGE_CHANGE':
                    type = '科室leader变更通知';
                    path = '/#/hospital/departmentDetail';
                    params = parseQueryConditions(queryConditions);
                    break;
            case 'REQUEST_PAY_USER_CHANGE':
                type = '科室请款负责人变更通知';
                path = '/#/hospital/departmentDetail';
                params = parseQueryConditions(queryConditions);
                break;
            case 'PM_VIRTUAL_LINE_CHANGE':
                type = 'PM虚拟汇报线变更通知';
                path = '/#/user/DashedReport';
                params = parseQueryConditions(queryConditions);
                break;
            case 'SET_USER_HOSPITAL_COURTYARD_AREA':
                type = '医院院区配置通知';
                path = '/#/user/userInfo';
                params = parseQueryConditions(queryConditions);
                break;
            case 'RESPONSIBLE_HOSPITAL_NOTICE':
                type = '负责医院科室通知';
                path = '/#/user/userInfo';
                params = parseQueryConditions(queryConditions);
                //跳转到 人员主要/次要负责医院科室 页签
                params.activeKey = 'chargeHospital';
                break;
            case 'AUTHORITY':
                type = '授权通知';
                path = record.targetWeb == 'OUT_INV_INV_LIST' ? `AUTHORITY` : `/#/contractManagement/responseCustomer`;
                params.activeKey = record.targetWeb == 'OUT_INV_END_INV_LIST' ? '0' : '1';
                clearCenter(setSession);
                break;
            case 'INVESTIGATION_REQUIREMENT':
                type = '需求通知';
                if (webCondition == 'JUMP_TO_NEW_PAGE') {
                    if (targetWeb == 'OUT_INV_REQUIREMENT') {
                        if(roleCode !== 'CRC') path = `/#/user/require/${relateId}`;
                    } else {
                        path = `/#/member/require/${relateId}`;
                        setCenter(setSession, params);
                        setSession.curRole = roleCode;
                    }
                }
                break;
            case 'HANDOVER_REQUIREMENT':
                type = '交接通知'
                if (webCondition == 'JUMP_TO_NEW_PAGE') {
                    if( params.target &&  params.target == 'invPmHandover'){
                        this.props.saveParams({...params, type:'PM'});
                        path = `/#/execute/transfer/`;
                        setProject(setSession, params, true);
                        setSession.curRole = roleCode;
                    }else if(params.target &&  params.target == 'pmHandover'){
                        path = `/#/user/pmTransfer/`;
                        clearCenter(setSession);
                    }else if (roleCode == 'CRCM' || roleCode == 'CRCC') {
                        path = `/#/user/transfer/${relateId}`;
                        clearCenter(setSession);
                    } else {
                        path = `/#/execute/transfer/${relateId}`;
                        setCenter(setSession, params);
                        setSession.curRole = roleCode;
                    }
                }
                break;
            case 'PM_HANDOVER_REQUIREMENT':
                type = 'PM交接通知';
                if( params.target &&  params.target == 'invPmHandover'){
                    if(webCondition == 'NOT_JUMP'){
                        path = "javascript:void(0)"
                    }else{
                        this.props.saveParams({...params, type:'PM'});
                        path = `/#/execute/transfer/`;
                        setProject(setSession, params, true);
                        setSession.curRole = roleCode;
                    }
                }else {
                    path = `/#/user/pmTransfer/`;
                    clearCenter(setSession);
                }
                break;
            case 'MANHOUR':
                type = '工时通知';
                path = relateId ? `/#/manHour/write/${relateId}/${noticeInfo.substring(0, 10)}` : 'javascript:void(0)';
                break;
            case 'MANHOUR_MODIFY_FINISH':
                type = '工时通知'
                if (fp.contains(roleCode, ['BO', 'PM', 'PML', 'CRCM', 'CRCC', 'CRC', 'PA']) && relateId) {
                    path = `/#/manHour/confirm/${(queryConditions) && (queryConditions).slice(9)}/${relateId}`
                    setCenter(setSession, params);
                } 
                break;
            case 'MANHOUR_MODIFY':
                type = '工时通知'
                if (fp.contains(roleCode, ['BO', 'PM', 'PML', 'CRCM', 'CRCC', 'CRC', 'PA']) && relateId) {
                    path = targetWeb == 'IN_INV_SITE_MAN_HOUR_SUMMARY' ? `/#/execute/manHour/${relateId}` : `/#/manHour/myHour/${(queryConditions) && (queryConditions).slice(9)}/${relateId}`;
                    setCenter(setSession, params);
                } 
                break;
            case 'MANHOUR_MODIFY_RECEIVE':
                type = '工时修改确认提醒'
                if (fp.contains(roleCode, ['BO', 'PM', 'PML', 'CRCM', 'CRCC', 'CRC', 'PA']) && relateId) {
                    path = `/#/manHour/confirm/${(queryConditions) && (queryConditions).slice(9)}/${relateId}`
                    setCenter(setSession, params);
                }
                break;
            case "MANHOURVERIFY":
                type = '工时确认提醒';
                path = relateId ? `/#/execute/manHour/${relateId}` : 'javascript:void(0)';
                setProject(setSession, params, true);
                break;
            case 'INVESTIGATION_STAGE_REMIND':
                type = '项目阶段更新提醒';
                path = `/#/invDetails`;
                setSession.curRole = roleCode;
                setProject(setSession, params);
                break;
            case 'INVESTIGATION_THRESHOLD_APPLY':
                type = '项目完工Total阀值超限申请';
                path = `/#/sumTotal/percent`;
                setSession.curRole = roleCode;
                setProject(setSession, params, true);
                break;
            case 'JDE_APPLY':
                type = 'JDE建号申请通知';
                if (roleCode == 'PM') {
                    path = `/#/projectContract/applyJdeCode`;
                    setSession.curRole = roleCode;
                    setProject(setSession, params, true);
                }else if(roleCode == 'FIN'){
                    path = `/#/contractManagement/applyJdeCode/${params.jdeApplyCode}`;
                    if (roleCode) {
                        setSession.curRole = roleCode;
                    }
                    clearCenter(setSession);
                }else {
                    path = `/#/contractManagement/applyJdeCode`;
                    if (roleCode && roleCode !== 'TAL') {
                        setSession.curRole = roleCode;
                    }
                    clearCenter(setSession);
                }
                break;
            case 'JDE_MAIN_APPLY':
                type = 'JDE主项目号变更申请通知';
                if (roleCode == 'PM') {
                    path = `/#/projectContract/alterJdeCode`;
                    setSession.curRole = roleCode;
                    setProject(setSession, params, true);
                } else {
                    path = `/#/contractManagement/alterJdeCode`;
                    if (roleCode) {
                        setSession.curRole = roleCode;
                    }
                    clearCenter(setSession);
                }
                break;
            case 'CONTRACT_COMPLETE_APPLY':
                type = '合同确认请款完成通知';
                path = `/#/contractManagement/contractRecord`;
                params.path = '/contractManagement/contractRecord';
                params.investigationJdeCode = record.investigationJdeCode;
                if (roleCode) {
                    setSession.curRole = roleCode;
                }
                break;
            case "REMITTANCE_REGISTER": {
                type = "合同请款记录登记通知";
                path = `REMITTANCE_REGISTER`;
                params.investigationJdeContractId = relateId;
                const { positionRole } = sessionStorage;
                setSession.curRole = positionRole;
                clearCenter(setSession);
                break;
            }
            case 'CASH_REQ':{
                type = '合同请款通知';
                path = `/#/contractManagement/requestRecord`;
                params.investigationJdeContractCode = record.investigationJdeContractCode;
                if (roleCode) {
                    setSession.curRole = roleCode;
                }
                clearCenter(setSession);
                break;
            }
            case 'REMITTANCE_ADJUST_APPLY': {
                type = '合同请款调整申请通知';
                path = `/#/contractManagement/requestRecord`;
                params.remittanceCode = params.remittanceCode ? params.remittanceCode : record.remittanceCode;
                clearCenter(setSession);
                break;
            }
            case "CONTRACT_COMPLETE_APPLY_TOW": {
                type = "合同确认请款完成通知";
                path = `/#/contractManagement/contractRecord`;
                params.path = '/contractManagement/contractRecord';
                const { positionRole } = sessionStorage;
                setSession.curRole = positionRole;
                clearCenter(setSession);
                break;
            }
            case 'REMITTANCE_CUSTOMER_APPLY':
                type = '客户付款单位调整申请';
                path = `/#/contractManagement/requestRecord`;
                params.remittanceCode = params.remittanceCode ? params.remittanceCode : record.remittanceCode;
                if (roleCode) {
                    setSession.curRole = roleCode;
                }
                clearCenter(setSession);
                break;
            case 'INV_COMPLETE_APPLY':
                type = '项目确认请款完成通知';
                path = `/#/contractManagement/contractRecord`;
                params.path = '/contractManagement/contractRecord';
                if (roleCode) {
                    setSession.curRole = roleCode;
                }
                clearCenter(setSession);
                break;
            case "CONTRACT_RELATE_SITE": {
                type = '中心关联合同通知';
                path = `CONTRACT_RELATE_SITE`;
                setSession.curRole = roleCode;
                params.readStatus = readStatus;
                setProject(setSession, params);
                break;
            }
            case 'USER_TEACHER_REMIND':
                type = '新人带教老师登记通知';
                path = 'USER_TEACHER_REMIND';
                params.userId = relateId;
                break;
            case 'CRC_EVALUATE_REMIND': {
                type = '带教质量评估提醒';
                const { positionRole } = sessionStorage;
                if (roleCode === 'CRC' && positionRole === 'CRC') {
                    path = '/#/teaching/qualityAssessmentSheet';
                    clearCenter(setSession);
                }
                break;
            }
            case 'CRC_HAVE_EVALUATED_REMIND':
                type = '带教质量评估提醒';
                path = '/#/teaching/management';
                clearCenter(setSession);
                break;
            case "COMPLAINT_RISK_CONFIRM": {
                type = '投诉风险等级确认';
                path = `/#/qualityManagement/complaintRegistrationForm`;
                break;
            }
            case "CONTRACT_MODIFY_NOTICE": {
                type = "合同信息变更申请通知";
                path = `CONTRACT_MODIFY_NOTICE`;
                if (roleCode === 'PM' && record.fieldType === 'contractType') {
                    setSession.curRole = 'PM';
                    setProject(setSession, params, true);
                } else {
                    const { positionRole } = sessionStorage;
                    setSession.curRole = positionRole;
                    clearCenter(setSession);
                }
                break;
            }
            case "CASH_REQ_NODE_REACH":
            case "MILESTONE_REACH_NOTICE":
            case "MILESTONE_DATE_REACH_NOTICE":
                if (noticeType === 'CASH_REQ_NODE_REACH') {
                    type = "请款节点到达通知";
                    path = `CASH_REQ_NODE_REACH`;
                } else if (noticeType === 'MILESTONE_REACH_NOTICE') {
                    type = "milestone到达日期登记通知";
                    path = `MILESTONE_REACH_NOTICE`;
                } else if (noticeType === 'MILESTONE_DATE_REACH_NOTICE') {
                    type = "milestone到达日期通知";
                    path = `MILESTONE_DATE_REACH_NOTICE`;
                } 
                if (roleCode === 'PM') {
                    setSession.curRole = 'PM';
                    setProject(setSession, params, true);
                } else {
                    const { positionRole } = sessionStorage;
                    setSession.curRole = positionRole;
                    clearCenter(setSession);
                }
                break;
            case "VITAE_APPROVAL": {
                type = '个人简历审批通知';
                path = `VITAE_APPROVAL`;
                params.relateId = relateId;
                break;
            }
            case 'VISIT_APPROVAL':{
                type = '访视周期计划发布确认';
                path = 'VISIT_APPROVAL';
                setSession.curRole = roleCode;
                setProject(setSession, params);
                params = {
                    path : (!params.handlerStatus && webCondition !== 'NOT_JUMP' && parseQueryConditions(queryConditions, null, 'sp_qucon').target
                    =='outInv') ? `/#/executeMgr/visitPeriodPlanHandle`: (!params.handlerStatus && webCondition !== 'NOT_JUMP' && parseQueryConditions(queryConditions, null, 'sp_qucon').target
                    =='inInv') ? `/#/executeMgr/visitPeriodPlan` : 'javascript:void(0)',
                    webCondition: webCondition,
                }
                break;
            }
            case 'NATION_VERIFY_ADD':{
                type = '国家核查通知';
                path = 'NATION_VERIFY_ADD';
                break;
            }
            case 'CONTRACT_BACK_CONFIRM_NOTICE': {
                type = '发票和回款记录确认通知';
                path = '/#/projectContract/returnedMoney';
                break;
            }
            case 'INVESTIGATION_FINISH_PERCENT_CONFIRM': {
                type = '完工进度确认';
                path = `INVESTIGATION_FINISH_PERCENT_CONFIRM`;
                params = parseQueryConditions(queryConditions, null, '&');
                break;
            }
            case 'SSU_HOSPITAL_INFO_CONFIRM': {
                type = '办事流程确认提醒';
                path = `SSU_HOSPITAL_INFO_CONFIRM`;
                params.relateId = relateId;
                break;
            }
            case 'Refunded_Invoice': {
                type = '回款到期提醒';
                path = `/#/contractManagement/requestRecord`;
                const { positionRole } = sessionStorage;
                params = parseQueryConditions(queryConditions);
                setSession.curRole = positionRole;
                clearCenter(setSession);
                break;
            }
            case 'EVALUATE_RECORD_MESSAGE': {
                type = '临床评估通知';
                path = targetWeb == 'OUT_INV_BUSINESS_QUOTATION' ? `/#/businessOffer/businessOfferRecord` : `/#/clinicalEvaluation/clinicalEvaluationRecord`;
                params = parseQueryConditions(queryConditions);
                break;
            }
            case 'REMIND_AUTHORIZATION_DATE': {
                type = '授权时间确认提醒';
                path = `/#/member/crc`;
                setSession.curRole = roleCode;
                setCenter(setSession, params);
                params = parseQueryConditions(queryConditions);
                break;
            }
            case 'VACATION_RECORD_MESSAGE': {
                type = '项目成员休假提醒';
                path = "javascript:void(0)";
                break;
            }
            case 'BUSINESS_QUOTATION_MESSAGE': {
                type = '商务报价通知';
                path = `/#/businessOffer/businessOfferRecord`;
                params = parseQueryConditions(queryConditions);
                break;
            }
            case 'COV_TIME_REGISTER': {
                type = 'COV计划时间登记通知';
                path = `/#/teaching/management`;
                params = parseQueryConditions(queryConditions);
                break;
            }
            case 'PERSONAL_FILE_UPLOAD': {
                type = '个人文档上传通知';
                if (targetWeb == 'OUT_INV_SELF_VITAE') {
                    path = `/#/personal/curriculumVitae`;
                } else if (targetWeb == 'OUT_INV_EMP_VITAE_DETAIL') {
                    path = `/#/user/userResume`;
                } else if (targetWeb == 'OUT_INV_EMP_FILE') {
                    path = `/#/personal/file`;
                } else if (targetWeb == 'IN_INV_SITE_FILE_MANAGE') {
                    setCenter(setSession, params);
                    path = `/#/fileManagement/projectFile`;
                } else {
                    path = 'javascript:void(0)';
                }
                params = parseQueryConditions(queryConditions);
                break;
            }
            case 'PERSONAL_VITAE_APPROVE': {
                type = '个人简历审批通知';
                path = `/#/personal/file`;
                params = parseQueryConditions(queryConditions);
                break;
            }
            case 'INV_CLOSE_REMIND': {
                type = '项目确认关闭通知';
                path = `/#/contractManagement/contractRecord`;
                params = parseQueryConditions(queryConditions);
                params.path = '/contractManagement/contractRecord';
                if (roleCode) {
                    setSession.curRole = roleCode;
                }
                clearCenter(setSession);
                break;
            }
            case 'FINANCIAL_ADJUST': {
                type = '财务数据调整通知';
                path = `/#/contractManagement/contractRecord`;
                params = parseQueryConditions(queryConditions);
                params.path = '/contractManagement/contractRecord';
                if (roleCode) {
                    setSession.curRole = roleCode;
                }
                clearCenter(setSession);
                break;
            }
            case 'NOT_SPECIFIES_AMOUNT_ADJUST': {
                type = '非明标合同额调整通知';
                path = `/#/contractManagement/contractRecord`;
                params = parseQueryConditions(queryConditions);
                params.path = '/contractManagement/contractRecord';
                if (roleCode) {
                    setSession.curRole = roleCode;
                }
                clearCenter(setSession);
                break;
            }
            case 'THRESHOLD_IMMINENTLY_EXCEED':
                type = '项目完工Total阀值即将超限预警通知';
                path = `/#/sumTotal/percent`;
                setSession.curRole = roleCode;
                setProject(setSession, params, true);
                break;
            case 'THRESHOLD_EXCEED_LIMIT':
                type = '项目完工Total阀值超限通知';
                path = `/#/sumTotal/percent`;
                setSession.curRole = roleCode;
                setProject(setSession, params, true);
                break;
            case 'MAJOR_EVENT_MESSAGE': {
                type = '重大事件通知';
                if (targetWeb === 'OUT_INV_MAJOR_EVENT') {
                    // 解析查询条件，将重大事件编号/单号存入sessionStorage，供重大事件页面自动过滤
                    const queryParams = parseQueryConditions(queryConditions);
                    if (queryParams.majorEventNumber) {
                        sessionStorage.majorEventNumber = queryParams.majorEventNumber;
                    }
                    if (queryParams.primaryEventNumber) {
                        sessionStorage.primaryEventNumber = queryParams.primaryEventNumber;
                    }
                    this.confirmNoticeReadByOne(userScheduleId);
                    location.href = '/#/qualityManagement/importantEvent';
                    return;
                } else if (targetWeb === 'IN_INV_SUMMARY_MAJOR_EVENT' || targetWeb === 'IN_INV_SITE_MAJOR_EVENT') {
                    this.handleMajorEventInInv(record, userScheduleId, queryConditions);
                    return;
                }
                break;
            }
        }
        if(webCondition !== 'JUMP_TO_NEW_PAGE') path = 'javascript:void(0)';
        this.handelClickNotice(path, setSession, userScheduleId, index, params)
    }

    getColumns = () => {
        const columns = [];
        columns.push({
            title: <span style={{paddingLeft:'20px'}}>消息类型</span>,
            dataIndex: 'noticeTypeValue',
            key: 'noticeTypeValue',
            width: 200,
            render: (text, record) => {
                const { readStatus } = record;
                return (
                    <span>
                        <span style={{color:'#5750b7', fontSize:'16px', width:16, display:'inline-block'}}>{readStatus !== 'READ' ? '●' : ''}</span>
                        <span style={{color: readStatus !== 'READ' ? '#5750b7' : 'rgba(0,0,0,.65)'}}>{text}</span>
                    </span>
                )
            }
        }, {
            title: '消息内容',
            dataIndex: 'noticeInfo',
            key: 'noticeInfo',
            render: (text, record, index) =>{
                const { readStatus } = record;
                return <span style={{cursor:'pointer', color: readStatus !== 'READ' ? '#5750b7' : 'rgba(0,0,0,.65)'}} onClick={() => {this.clickNotice(text , record , index)}}>{text}</span>
            }
        }, {
            title: '操作',
            width: 180,
            dataIndex: 'createTime',
            key: 'createTime',
            render: (text, record) => {
                const { userScheduleId } = record;
                return(
                    <span>
                        <Popconfirm title='确定标记此待办事项已处理吗?' 
                            onConfirm={() => this.handleComplate({ markType: 'SINGLE' }, userScheduleId)} 
                            okText="确定" 
                            cancelText="取消"
                        >
                            <a>标记为已处理</a>
                        </Popconfirm>
                        <br />
                        <span style={{color:'#cccccc'}}>{moment(text).format('YYYY-MM-DD')}</span>
                    </span>
                )
            }
        })
        return columns
    }

    handleTableChange = params => {
        this.setState(params, this.loadData)
    }

    render() {
        const { pagination, data, auditJdeParams, expectHourParams, loading,centerRelateParams } = this.state;
        const { searchParams, saveSearchParams, panes, activeKey, handleTabClick } = this.props;

        return (
            <div className="full">
                <Spin spinning={loading}>
                    <div style={{ color: '#3D33A9' }}><index className='icon iconfont'>&#xe65b;</index>消息</div>
                    <Filter 
                        search={this.search} 
                        saveSearchParams={saveSearchParams} 
                        searchParams={searchParams}
                        bacthHandleComplate={this.bacthHandleComplate}
                    />
                    <div style={{ width: "80%", margin: "0 auto" , marginBottom: "-16px"  }}>
                        <Tabs type="card" activeKey={activeKey} onChange={handleTabClick}>
                            {panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{pane.content}</TabPane>)}
                        </Tabs>
                    </div>
                    <div style={{ width: "80%", margin: "0 auto" }}>
                        <TableC 
                            bordered={false} 
                            data={data} 
                            className='Backlog'
                            pagination={pagination} 
                            columns={this.getColumns()} 
                            onChange={this.handleTableChange}
                        />
                    </div>
                    <AuditJDE auditJdeParams={auditJdeParams} hideAuditJDE={this.hideAuditJDE} />
                    <ExpectHour expectHourParams={expectHourParams} hideExpectHour={this.hideExpectHour} loadData={this.loadData} />
                    <ConterctRelateSite centerRelateParams={centerRelateParams} hideCenterctRelateSite={this.hideCenterctRelateSite} loadData={this.loadData} confirmNoticeReadByOne={this.confirmNoticeReadByOne}/>
                    <ApproveCancelApply ref={el => this.approveRef = el} loadData={this.loadData} />
                    <RegisterRequest ref={el => this.requestRef = el} autoRegisterRequest={this.autoRegisterRequest} loadData={this.loadData} />
                    <ApproveBaBatchTransfer ref={el => this.approveBaTransferRef = el} loadData={this.loadData} />
                    <BaBatchTransfer ref={el => this.baTransferRef = el} loadData={this.loadData} />
                    <BacthHandle ref={el => this.bacthHandleRef = el} loadData={this.loadData} handleComplate={this.handleComplate}/>
                    <RoleSelectionModal ref={el => this.roleSelectionModelRef = el} selectRole={this.selectRoleForMajorEvent} />
                </Spin>
            </div>
        );
    }
}

const mapSateToProps = (state) => ({
    searchParams: state.noticeState.searchParams || {},
});

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
        saveSearchParams: (params) => dispatch(saveSearchParams(params)),
        saveProjectParams: (params) => dispatch(saveProjectParams(params)),
        saveResumeParams: (params) => dispatch(saveResumeParams(params)),
    }
}

export default connect(mapSateToProps, mapDispatchToProps)(Backlog);



// WEBPACK FOOTER //
// ./src/components/layout/notice/Backlog.js